module.exports = __webpack_public_path__ + "static/media/briiing-default.6c5a37e9.svg";